import React from 'react'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import LogoIcon from '@assets/images/logo/svg/logo-loader.svg'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 9,
  },
  text: {
    display: 'inline-block',
    fontSize: 12,
    marginTop: 15,
  },
  pulse: ({ customAnimation }) => {
    return {
      animation: customAnimation || 'pulse 2s ease infinite',
    }
  },
  '@keyframes pulse': {
    '0%': { fill: '#135899' },
    '50%': { fill: '#EE751C' },
    '100%': { fill: '#135899' },
  },
  '@keyframes spin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
}))

const LoaderInline = (props) => {
  const { customClass, text, height, width, visible, className, customIcon, customAnimation } = props
  const classes = useStyles({ customAnimation })

  if (!visible) return null

  return (
    <div className={clsx(classes.container, customClass, className)} style={{ height, width }}>
      <SVGIcon height="50px" width="auto" svg={customIcon || LogoIcon} className={classes.pulse} />
      <span className={classes.text}>{text}</span>
    </div>
  )
}

LoaderInline.defaultProps = {
  visible: true,
  width: '100%',
  height: '100%',
}

export default LoaderInline
